import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "antd";
import { changeActiveStep } from "../../../reducers/test";
import GeneraterandomQuestion from "./generaterandomquestion";
import "./newtest.css";
import Alert from "../../common/alert";

const SelectQuestion = () => {
  const dispatch = useDispatch();
  const test = useSelector((state) => state.test);
  const selectedQuestions = test.newtestFormData.testQuestions;

  const handlePrevious = () => {
    dispatch(changeActiveStep(0));
  };

  const handleNext = () => {
    if (selectedQuestions.length > 0) {
      dispatch(changeActiveStep(2));
    } else {
      Alert("error", "Error!", "Please select at least one question.");
    }
  };

  return (
    <div>
      {/* No need to pass setNextFormData unless you use it in GeneraterandomQuestion */}
      <GeneraterandomQuestion mode="manual" />
      <div style={{ width: "100%", padding: "10px" }}>
        <Button style={{ float: "right" }} type="primary" onClick={handleNext}>
          Next
        </Button>
        <Button
          style={{ float: "right", marginRight: "1%" }}
          type="primary"
          onClick={handlePrevious}
        >
          Previous
        </Button>
      </div>
    </div>
  );
};

export default SelectQuestion;
